export const replaceLastMatchWith = (value: string, match: string, replaceValue?: string) => {
  const decodedValue = decodeURIComponent(value)
  const decodedMatch = decodeURIComponent(match)
  const decodedReplaceValue = replaceValue ? decodeURIComponent(replaceValue) : ''

  return decodedValue.substring(0, decodedValue.lastIndexOf(decodedMatch)) + decodedReplaceValue
}

export const includesIgnoreCase = (value: string, match: string) => {
  return value.toLowerCase().includes(match.toLowerCase())
}

// Case- and accent-insensitive match key. NFD splits an accented character into
// its base letter plus a combining mark, which the range below then strips, so
// "Gacha" matches "Gachá" and vice versa. Normalize both sides of a comparison.
export const normalizeForSearch = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

const HTML_TAG_PATTERN = /<[^>]*>/g
const HTML_NBSP_PATTERN = /&(?:nbsp|#160|#xa0);/gi

// Visible text of an HTML fragment: tags dropped, non-breaking-space entities
// treated as whitespace, then trimmed. Meant for emptiness checks on editor
// output such as `<p></p>`, `<p><br></p>` or `<p>&nbsp;</p>`, not for display.
export const htmlToTrimmedText = (html?: string | null): string => (html ?? '').replace(HTML_TAG_PATTERN, '').replace(HTML_NBSP_PATTERN, ' ').trim()

export const isHtmlBlank = (html?: string | null): boolean => htmlToTrimmedText(html) === ''
